// 共通要素を作成する(静的なHTMLを作成する)。

/*-------------------
    モジュールのimport
---------------------*/
import React from 'react';
/*-------------------
    classのimport
---------------------*/
import * as commons from './commons';

// リンク一覧を作成する。
export const linkList = (linkSettingData = '') => {
  const { link_setting: linkSetting = [] } = linkSettingData[0] || '';

  const dispLink = [];
  const openUrl = [];
  for (let i = 0; i < linkSetting.length; i += 1) {
    const { link = '', name = '', public_kind: kind = '' } = linkSetting[i];

    if (['0'].indexOf(kind) === -1) continue;

    dispLink.push(
      <li key={`linkSetting_${i}`}>
        <a href={link} target="_blank" rel="noreferrer noopener">
          {name}
        </a>
      </li>
    );
    openUrl.push(link);
  }

  if (dispLink.length === 0) return [];

  // ボタンクリック時に呼ばれる関数
  const openTabs = () => {
    openUrl.forEach((url) => {
      window.open(url, '_blank'); // 新しいタブで開く
    });
  };

  const linkContent = (
    <li className="settings">
      <input id="accordionMenu40" className="accordion" type="checkbox" />
      <label className="menuTitle accordion-label" htmlFor="accordionMenu40">
        {'関連サイトを見る'}
      </label>
      <div className="accordion-item">
        <ul>
          <button
            type="button"
            className="btnAtag"
            onClick={() => {
              openTabs();
            }}
          >
            全てのリンクを開く
          </button>
          {dispLink}
        </ul>
      </div>
    </li>
  );

  return linkContent;
};

// 同意画面の表示用
export const agreeModal = (agree, agreeInit) => {
  const { title = '', main = 0, dis_url: disUrl = '' } = agree || '';
  if (title === '') return [];

  const agreePush = () => {
    sessionStorage.setItem('agree', '1');
    agreeInit({ agreeFlag: true });
  };

  const disAgreePush = () => {
    if (disUrl === '') return;
    window.location.href = disUrl;
  };

  const linkContent = (
    <div className="modalBack">
      <div className="modalMain" id="agree">
        <div className="ag-title">{title}</div>
        <div className="ag-subTitle">閲覧には同意が必要です。</div>
        <div className="ag-main">{commons.shapedContents(main)}</div>
        <button className="btnAgree" type="button" onClick={() => agreePush()}>
          同意する
        </button>
        <button className="btnDisAgree" type="button" onClick={() => disAgreePush()}>
          同意しない
        </button>
      </div>
    </div>
  );

  return linkContent;
};

// コピペ用
export const test = () => {};
